import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import Layout from 'components/layout';
import Head from 'components/head';
import Form from 'components/form';
import Hero from 'components/hero';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 16px;
  justify-content: center;
  margin: 50px auto 100px auto;
  max-width: 1140px;
  @media (max-width: 768px) {
    margin-right: 24px;
    margin-left: 24px;
    grid-template-columns: 1fr;
    grid-row-gap: 16px;
  }
  p {
    margin-bottom: 48px;
    margin: 0;
    font-family: 'Nunito', sans-serif;
    font-weight: 400;
    font-size: 21px;
    line-height: 33px;
    color: #000000;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`

const Contact = ({ data }) => (
  <Layout>
    <Head pageTitle={data.contactJson.title} />
    <Hero hero={data.contactJson.hero} />
    <Container>
      <Form title={data.contactJson.title} content={data.contactJson.content}/>
    </Container>
  </Layout>
);

Contact.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Contact;

export const query = graphql`
  query ContactQuery {
    contactJson {
      title
      content
      hero {
        title
        content {
          childMarkdownRemark {
            html
          }
        }
        image {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;
